import React from "react";
import cx from "classnames";

const CardSubheader = ({ subheader, isExpandable }) => {
  return (
    <div className="mb-6 agrandir">
      <h2 className="text-2xl text-black font-bold mb-1">
        <a
          className={cx("no-underline", {
            "hover:text-blue-darker cursor-pointer": isExpandable
          })}
        >
          {subheader}
        </a>
      </h2>
    </div>
  );
};

export default CardSubheader;
